import { createGlobalState } from '@vueuse/core';
import { useRoute } from 'vue-router/composables';
import { computed } from 'vue';
import { fullViewRouterNames } from '@/subview_plugins/install';

export const usePatentViewUrlParams = createGlobalState(() => {
    const route = useRoute();

    const isFullView = computed(() => {
        return fullViewRouterNames.includes(route?.meta?.pluginName);
    });

    /* 
        权利要求对比左侧target id
    */
    const targetId = computed(() => {
        return route.params?.targetId;
    });

    /* 
        权利要求对比右侧 source id
    */
    const sourceId = computed(() => {
        return route.params?.sourceId;
    });

    return {

        targetId,
        sourceId,
        isFullView,
    };
});